export default "__VITE_ASSET__CWaJFwM7__"